import { PropsWithChildren, createContext, useContext, useMemo } from 'react';

import { useDataProvider } from '../../../hooks/data-provider/data-provider.hook';
import { FilterSelectedValue } from '../../../hooks/filters/interfaces/filter-selected-value.interface';
import { REPORT_NAMES } from '../../reports/constants/report-names.constants';

interface AccessDto {
  MARKET_KEY: number;
  access: number;
}
interface AccessContextInfo {
  accessInfo: AccessDto[];
}
export const AccessContext = createContext<AccessContextInfo>({
  accessInfo: [],
});
interface AccessProviderProps extends PropsWithChildren {
  filterSelection: FilterSelectedValue[];
}
/**
 *
 *
 */
export const AccessProvider = ({
  children,
  filterSelection,
}: AccessProviderProps) => {
  const { data } = useDataProvider<AccessDto>(
    REPORT_NAMES.ACCESS_INFO,
    filterSelection,
    [],
    true,
    false,
  );

  const accessInfoValue = useMemo((): AccessContextInfo => {
    if (data && data.rows) {
      return { accessInfo: data.rows };
    } else {
      return { accessInfo: [] };
    }
  }, [data]);
  return (
    <AccessContext.Provider value={accessInfoValue}>
      {children}
    </AccessContext.Provider>
  );
};

export const useAccessContext = () => {
  const context = useContext(AccessContext);

  return context.accessInfo;
};
